import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import { File } from '../../file/File'
import type { ChatBatchResult } from '../ChatBatchResult'

@InputType()
export class ChatBatchReplyInput {
  @Field(() => ID)
  chatId: string

  @Field(() => String)
  content: string

  @Field(() => [File], { nullable: true })
  attachments?: File[]
}

@InputType()
export class BatchReplyToChatsArgs extends ActionArgs {
  @Field(() => [ChatBatchReplyInput])
  replies: ChatBatchReplyInput[]
}

export interface IBatchReplyToChats extends IAction<ChatBatchResult, BatchReplyToChatsArgs> {}
